import './home.css';
import * as React from 'react'
import {Component} from "react";
import {setActiveMenuItem, setLogoWhite, setNavbarTheme} from "../../util";


export class Home extends Component {

    componentDidMount() {
        setNavbarTheme('#FFFFFF');
        setActiveMenuItem('', window.innerWidth < 1000);
        setLogoWhite(true);
    }

    render() {
        return (
            <div className={'home'}>
                <div className={'home-image'}/>
                <div className={'home-slogan'}>
                    <p>Bærekraft i blodet.<br/><br/></p>
                </div>
            </div>
        )
    }
}